import { JSX, useMemo } from "react";

import { Typography } from "@mui/material";
import {
  ConfigurationAttributeResult,
  ConfigurationResult,
} from "@plansoft-configuration-renderer/configuration-api";
import { useCsConfiguration } from "@plansoft-configuration-renderer/framework";

interface DisplaySubstructureValueComponentProps {
  displayedValueAttributeId: string;
  path?: string;
}

function findAttributeInObjects(
  configuration: ConfigurationResult,
  attributeId: string,
  path?: string,
): ConfigurationAttributeResult | null {
  for (const obj of configuration.objects ?? []) {
    const found = obj.attributes?.find(
      (a) => a.id === attributeId && (!path || a.path?.includes(path)),
    );
    if (found) return found;
  }
  return null;
}

export function DisplaySubstructureValueComponent({
  displayedValueAttributeId,
  path,
}: DisplaySubstructureValueComponentProps): JSX.Element {
  const configuration = useCsConfiguration();

  const displayAttribute = useMemo(
    () =>
      findAttributeInObjects(configuration, displayedValueAttributeId, path),
    [configuration, displayedValueAttributeId, path],
  );

  const displayedValueUnit =
    displayAttribute?.unitSymbol ||
    displayAttribute?.unitName ||
    displayAttribute?.unitId ||
    "";

  return (
    <Typography color={"primary"} sx={{ fontWeight: "bold" }}>
      {
        displayAttribute?.values?.find((v) => v.isSelected || v.isEditable)
          ?.value
      }{" "}
      {displayedValueUnit}
    </Typography>
  );
}
